module.exports = __webpack_public_path__ + "static/img/report3D_cover_2.947c361c.png";